
namespace Areas.Projects {
    "use strict";


    export function cellPreparedStatusColor(e) {
        if (e.rowType == 'data' && e.column.dataField === "statusLk") {
            if (e.data.statusLk === "Accepted") {
                e.cellElement.css('background-color', 'lightgreen');
            }
            else if (e.data.statusLk === "Pending") {
                e.cellElement.css('background-color', 'gold');
            }
            else if (e.data.statusLk === "ReInspected") {
                e.cellElement.css('background-color', 'pink');
            }
            else if (e.data.statusLk === "Rejected") {
                e.cellElement.css('background-color', 'red');
            }
        }
    }

}